import React, { useCallback, Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import {
    Card,
    CardBody,
    // CardTitle,
    // CardSubtitle,
    Button,
    Col,
    // Modal,
    // ModalHeader,
    // ModalBody,
    // Label,
    // Form,
    // FormGroup,
    // Col
} from 'reactstrap';
import { useAuth } from '../../Context/Auth/AuthContext';
import ReachOutLabels from '../../enums/ReachOutLabels';

export default function CardNoGroups(props) {
    // const { showCreateBtn, showJoinBtn, noGroups } = props;
    const history = useHistory();
    const { authenticated } = useAuth();

    // const [modalZip, setModalZip] = useState(false);
    // const toggleModalZip = useCallback(() => {
    //     setModalZip(!modalZip);
    // }, [setModalZip, modalZip]);
    // const [zipCode, setZipCode] = useState('');
    // const toggleZipCode = useCallback((e) => {
    //     setZipCode(e.target.value);
    // }, [setZipCode]);

    // const onSubmitCreate = useCallback(async () => {
    //     history.push('/group/create');
    // }, [history]);

    // const onSubmitJoin = useCallback(async () => {
    //     console.log(zipCode);
    //     toggleModalZip();
    //     history.push('/group/search');
    // }, [zipCode, toggleModalZip, history]);

    const userInfo = useCallback(() => {
        if (authenticated.user) {
            return authenticated.user;
        } else {
            return authenticated;
        }
    }, [authenticated]);

    // const defaultSenior = () => {
    //     const user = userInfo();
    //     if (user.defaultRole && user.defaultRole === 'receiver') {
    //         return true;
    //     } else {
    //         return false;
    //     }
    // }

    const getTitle = useCallback(() => {
        let message = '';
        if (userInfo().role === 'coordinator') {
            message = 'Start a new group';
        } else {
            message = 'Search for a group';
        }
        return message;
    }, [userInfo]);

    // const getSubtitle = useCallback(() => {
    //     let message = '';
    //     if (noGroups) {
    //         message = `Try the following options:`;
    //     } else {
    //         message = `Search for groups near you!`
    //     }
    //     return message;
    // }, [noGroups]);

    const goToCreateGroup = useCallback(() => {
        history.push('/group/create');
    }, [history]);

    const goToSearchGroup = useCallback(() => {
        history.push('/group/search');
    }, [history]);

    const goToResources = useCallback(() => {
        history.push('/resources');
    }, [history]);

    return (
        <Fragment>

            <Col sm="4" className="mb-4">
                <Card className="main-card mb-3">
                    <CardBody>
                        <div className="grid-menu grid-menu-2col">
                            <Button
                                className="btn-icon-vertical btn-square btn-transition"
                                outline
                                color="link"
                                onClick={() => {
                                    if (userInfo().role === 'coordinator') {
                                        goToCreateGroup();
                                    } else if (userInfo().role !== 'coordinator') {
                                        goToSearchGroup();
                                    }
                                }}
                            >
                                {userInfo().role === 'coordinator' && (
                                    <i className="lnr-plus-circle btn-icon-wrapper btn-icon-lg mb-3">
                                        {' '}
                                    </i>
                                )}
                                {userInfo().role !== 'coordinator' && (
                                    <i className="lnr-magnifier btn-icon-wrapper btn-icon-lg mb-3">
                                        {' '}
                                    </i>
                                )}
                                
                                {getTitle()}
                                <br />
                                <small>As&nbsp;
                                    {
                                        ReachOutLabels[
                                            userInfo()
                                                .role
                                        ]
                                    }
                                </small>
                            </Button>
                            <div className="text-center">
                                <div className="btn-group">
                                    {userInfo().role === 'coordinator' && (
                                        <Button
                                            className="btn-wide mb-2 mr-2"
                                            color="primary"
                                            onClick={goToCreateGroup}
                                        >
                                            Create group
                                        </Button>
                                    )}
                                    {userInfo().role !== 'coordinator' && (
                                        <Button
                                            className="btn-wide mb-2 mr-2"
                                            color="primary"
                                            onClick={goToSearchGroup}
                                        >
                                            Search
                                        </Button>
                                    )}
                                    
                                </div>
                            </div>
                        </div>

                        {/* <CardTitle>{getTitle()}</CardTitle>
                        <CardSubtitle>{getSubtitle()}</CardSubtitle>
                        {showCreateBtn && (
                            <Button 
                            color="success" 
                            className="m-2"
                            onClick={onSubmitCreate} >
                                Create a group
                            </Button>
                        )}

                        {showJoinBtn && (
                            <Fragment>
                                <Button 
                                    color="primary" 
                                    className="m-2"
                                    onClick={toggleModalZip}
                                >
                                    Search for Groups
                                </Button>

                                <Modal isOpen={modalZip} toggle={toggleModalZip}>
                                    <ModalHeader toggle={toggleModalZip}>
                                        ZIP Code
                                    </ModalHeader>
                                    <ModalBody>
                                        <Form>
                                            <FormGroup row>
                                                <Label
                                                    for="zip"
                                                    sm={12}
                                                >
                                                    Please type your ZIP Code:
                                                </Label>
                                                <Col sm={12}>
                                                    <input
                                                        type="text"
                                                        name="zip"
                                                        id="zip"
                                                        className="form-control"
                                                        onChange={toggleZipCode}
                                                    />
                                                </Col>
                                            </FormGroup>                                    
                                            <FormGroup check row>
                                                <Col sm={{ size: 12}}>
                                                    <Button
                                                        onClick={onSubmitJoin}
                                                        color="info"
                                                    >
                                                        Search
                                                    </Button>
                                                    <Button
                                                        onClick={toggleModalZip}
                                                        color="secondary"
                                                        className="ml-2"
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Col>
                                            </FormGroup>
                                        </Form>
                                    </ModalBody>
                                </Modal>

                            </Fragment>
                        )} */}
                    </CardBody>
                </Card>
            </Col>

            <Col sm="4" className="mb-4">
                <Card className="main-card mb-3">
                    <CardBody>
                        <div className="grid-menu grid-menu-2col">
                            <Button
                                className="btn-icon-vertical btn-square btn-transition"
                                outline
                                color="link"
                                onClick={goToResources}
                            >
                                <i className="lnr-laptop-phone btn-icon-wrapper btn-icon-lg mb-3">
                                    {' '}
                                </i>
                                
                                RESOURCES
                                <br />
                                <small>Programs and Tools
                                    {/* ReachOutLabels[
                                            userInfo()
                                                .role
                                        ]*/
                                    }
                                </small>
                            </Button>
                            <div className="text-center">
                                <div className="btn-group">
                                    <Button
                                        className="btn-wide mb-2 mr-2"
                                        color="primary"
                                        onClick={goToResources}
                                    >
                                        Resources
                                    </Button>                                
                                </div>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Col>
            

            
        </Fragment>
        
    );
}
